import {
  DecoratedInvestorCompany,
  UndecoratedFinancialReport,
} from '@flemingmetrics/api-client';
import { sumByKey } from '@/utils/arrays';
import { sumInvestments } from '@/utils/reports';

export const classes = {
  wrapper: 'grid gap-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-4 my-8',
  card: 'flex items-center justify-between',
  textWrapper: 'ml-4 flex flex-col justify-center',
  label: 'font-semibold text-sm text-grey-5 flex items-end justify-start',
  percentage: 'text-sm ml-2',
  positive: 'text-green-text',
  negative: 'text-red-3',
  price: 'font-semibold text-grey-6',
  warning: 'ml-2',
  warningIcon: 'text-red-2',
  flemingLogo: 'h-6 w-6',
  icon: 'rounded-xl text-sm h-10 w-10 flex items-center justify-center',
  molarIcon: 'bg-green-primary',
  investorIcon: 'bg-blue-3 text-white',
  investmentsIcon: 'bg-lavender-primary text-white',
  companyIcon: 'bg-rose-primary text-white',
  paymentIcon: 'bg-grey-6 text-white',
  profitIcon: 'bg-green-text text-white',
  rocketIcon: 'bg-blue-highlight text-white',
  scoreWrapper: 'flex',
};

export function sumTotalInvestments(
  investorCompanies: DecoratedInvestorCompany[],
  latestReports: UndecoratedFinancialReport[]
) {
  const summaries = investorCompanies.map((ic) =>
    sumInvestments(
      ic.investments.map((i) => ({ ...i, price: parseFloat(i.price) })),
      latestReports.find((r) => r.companyId === ic.companyId)
    )
  );
  const totalInvested = sumByKey(summaries, 'totalInvested');
  const currentValue = sumByKey(summaries, 'currentValue');
  return {
    companyCount: investorCompanies.length,
    missingCompanyCount: investorCompanies.length - latestReports.length,
    totalInvested,
    currentValue,
    profitLoss: {
      currency: latestReports[0]?.currency || 'EUR', // TODO
      deltaPrice: currentValue - totalInvested,
      deltaPercent: (currentValue - totalInvested) / totalInvested,
    },
  };
}
